import { Injectable } from '@angular/core';
import { LangService } from './lang.service';
import { IAccountType } from '../constants/account-types';

export interface IBreadcrumbRoute {
  route: string,
  caption: string,
}

@Injectable({
  providedIn: 'root'
})
export class BreadcrumbsService {

  constructor(
    private lang:LangService,
  ) { }

  private cLang(){
    return this.lang.getCurrentLanguage()
  }

  public learnMoreSection = {
    APPLICANT: 'applicant',
    TESTADMIN: 'testadmin',
  }

  _CURRENT(caption:string, route:string) { return { caption, route } }
  HOME() {                return { caption: 'Home',                 route: '/'} }
  APPLICANT_LANDING() {   return { caption: this.lang.tra('title_teach_app'),   route: `/${this.cLang()}/applicant/landing`} }
  TESTADMIN_LANDING() {   return { caption: this.lang.tra('title_test_admins'),  route: `/${this.cLang()}/testadmin/landing`} }
  APPLICANT_LEARNMORE() { return { caption: this.lang.tra('title_learn_more'), route: `/${this.cLang()}/applicant/learn`} }
  TESTADMIN_LEARNMORE() { return { caption: this.lang.tra('title_learn_more'), route: `/${this.cLang()}/testadmin/learn`} }
  TESTADMIN_DASHBOARD()   { return { caption: this.lang.tra('title_dashboard'), route: `/${this.cLang()}/${IAccountType.TEST_ADMIN}/dashboard`} }
  TESTADMIN_CREATE_TEST_SESSION(setupId:string, routeSuffix:string='test-window')   { return { caption: this.lang.tra('title_create_sessions'),          route: `/${this.cLang()}/${IAccountType.TEST_ADMIN}/create-test-sessions/${setupId}/${routeSuffix}`} }
  LEARNMORE_ARTICLE(caption:string, basePath:string, articlePath:string) {   return { caption, route: basePath+'/'+articlePath } }

}
